import { NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonLocalizationModule } from '@capital-access/common/localization';
import { Breakpoint, FireflyPopoverModule } from '@capital-access/firefly/components';
import { ManagedByInstitution } from '@capital-access/ownership/common';
import { TARGETING_COMMON_KEY } from '../../constants';
import { NaValuePipe } from '../../pipes/na-value.pipe';
@Component({
  selector: 'ca-multi-value-popover',
  templateUrl: './ca-multi-value-popover.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, NgFor, NgTemplateOutlet, FireflyPopoverModule, CommonLocalizationModule, NaValuePipe]
})
export class CaMultiValuePopoverComponent {
  L10N = TARGETING_COMMON_KEY;
  @Input() institutions: ManagedByInstitution[] = [];
  @Input() popoverTitle!: string;
  @Input() displayProperty!: string;

  get mobile(): boolean {
    return window.innerWidth < Breakpoint.Sm;
  }
}
